import { useParams } from "react-router-dom";
import { useOrganization } from "../../../../../hooks/query";

export default function useEditOrganization() {
    const { organizationId } = useParams<{ organizationId: string }>();
    const {
        useUpdate,
        useDescribe,
        useUploadLogo,
        useListContractTemplates,
        useOrganizationContractTemplate,
        useUpdateContractTemplate,
    } = useOrganization();

    const editOrganizationSvc = useUpdate();
    const uploadLogoSvc = useUploadLogo();
    const updateContractTemplateSvc = useUpdateContractTemplate();
    const { data: organizationData, isLoading, refetch } = useDescribe(organizationId as string);
    const {
        data: contractTemplates = [],
        isLoading: templatesLoading,
    } = useListContractTemplates();
    const {
        data: organizationContractTemplate,
        isLoading: assignmentLoading,
        refetch: refetchContractTemplate,
    } = useOrganizationContractTemplate(organizationId);

    const handleEditOrganization = async (data: any) => {
        try {
            const { LogoFile, ContractTemplateId, ...payload } = data;
            let logoUrl = payload.LogoUrl || null;

            if (LogoFile && organizationId) {
                const uploadResult = await uploadLogoSvc.mutateAsync({
                    OrganizationId: organizationId,
                    File: LogoFile,
                });
                logoUrl = uploadResult?.AssetId || logoUrl;
            }

            await editOrganizationSvc.mutateAsync({
                Id: organizationId,
                ...payload,
                LogoUrl: logoUrl || null,
            });

            if (organizationId && ContractTemplateId) {
                const currentId = organizationContractTemplate?.ContractTemplateId;
                if (ContractTemplateId !== currentId) {
                    await updateContractTemplateSvc.mutateAsync({
                        OrganizationId: organizationId,
                        ContractTemplateId,
                    });
                    await refetchContractTemplate();
                }
            }

            await refetch();
        } catch (error) {
            console.error("Failed to edit organization", error);
        }
    };

    return {
        editOrganizationSvc: {
            ...editOrganizationSvc,
            isPending:
                editOrganizationSvc.isPending ||
                uploadLogoSvc.isPending ||
                updateContractTemplateSvc.isPending,
            isError:
                editOrganizationSvc.isError ||
                uploadLogoSvc.isError ||
                updateContractTemplateSvc.isError,
            isSuccess:
                editOrganizationSvc.isSuccess &&
                !uploadLogoSvc.isError &&
                !updateContractTemplateSvc.isError,
        },
        handleEditOrganization,
        organizationData,
        contractTemplates,
        organizationContractTemplate,
        isLoading: isLoading || templatesLoading || assignmentLoading,
    };
}
